import {Component, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import "rxjs/add/observable/fromPromise";
import {Observable} from "rxjs/Observable";
import {DisposalsService, DisposalType} from "../../../../services/disposals.service";
import {SimpleDate} from "../../../../utils/simple-date";
import {NotificationsService} from "../../../../services/notifications.service";

@Component({
  selector: 'create-disposal-modal',
  templateUrl: 'create-disposal-modal.component.html'
})

export class CreateDisposalModalComponent {
  start: SimpleDate;
  end: SimpleDate;
  disposalType: DisposalType = DisposalType.AVAILABLE;
  errors: string[] = [];

  static open(modalService: NgbModal, start: SimpleDate, end: SimpleDate): Observable<boolean> {
    const modalRef = modalService.open(CreateDisposalModalComponent);
    modalRef.componentInstance.start = start;
    modalRef.componentInstance.end = end;
    return Observable.fromPromise(modalRef.result);
  }

  constructor(private activeModal: NgbActiveModal, private disposalService: DisposalsService, private notificationsService: NotificationsService) {
  }

  close() {
    this.activeModal.close(false);
  }

  remove() {
    this.disposalService.makeTentative(this.start, this.end).subscribe(
      () => this.activeModal.close(true),
      (response) => {
        const errorData = JSON.parse(response.error);
        this.errors = errorData.non_field_errors;
      }
    );
  }

  submit() {
    this.disposalService.createDisposal(this.disposalType, this.start, this.end).subscribe(
      () => this.activeModal.close(true),
      (response) => {
        const errorData = JSON.parse(response.error);
        this.errors = errorData.non_field_errors;
      }
    );
  }

}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/calendar/modals/create-disposal-modal.component.ts